<template>
    <div>
        <div class="actions">
            <button class="btn btn-primary" @click="create()">Pievienot jaunu līgumu</button>
        </div>
        <table class="table table-hover">
            <thead class="bg-primary text-white">
            <tr>
                <th>Numurs</th>
                <th>Datums</th>
                <th>Termiņš</th>
                <th>Otrā puse</th>
                <th>Mērķis</th>
                <th>Priekšmetu skaits</th>
                <th>Darbības</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="agreement in agreements">
                <td>{{agreement.agreement_number}}</td>
                <td>{{normalDate(agreement.agreement_date)}}</td>
                <td>{{normalDate(agreement.start_date)}} - {{normalDate(agreement.end_date)}}</td>
                <td>
                    <span v-if="agreement.receiver_type == 'individual'">{{agreement.receiver_firstname}} {{agreement.receiver_lastname}}</span>
                    <span v-if="agreement.receiver_type == 'legal_person'">{{agreement.receiver_institution_name}} ({{agreement.receiver_reg_number}}), {{agreement.receiver_position}} {{agreement.receiver_firstname}} {{agreement.receiver_lastname}}</span>
                </td>
                <td>{{agreement.purpose}}</td>
                <td>{{agreement.items_count}}</td>
                <td class="text-right">
                    <div class="itemActions">
                        <a :href="'/licences/show/'+agreement.id" class="action view"><span class="material-icons">visibility</span></a>
                        <div @click="deleteAgreement(agreement.id)" class="action delete" ><span class="material-icons">delete</span></div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <div v-if="agreements.length === 0" class="alert alert-info text-center">
            Šobrīd sistēmā nav neviens iekšējās kustības akts.
        </div>
    </div>
</template>


<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.actions{
    display:flex;
    justify-content: flex-end;
    margin-bottom:20px;
}
.itemActions{
    width:150px;
    display:flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    .action{
        cursor:pointer;
        padding:5px 15px;
        &.view{
            color:$blue;
        }
        &.delete{
            color:$red;
        }
    }
}
</style>
<script>
export default{
    mounted()
    {
        var that = this;
        axios.post('/licences/get-agreements').then(response =>{
            that.agreements = response.data.agreements;
        });
    },
    data()
    {
        return{
            loading:false,
            title:"",
            agreements:[]
        }
    },
    methods:{
        normalDateTime(date)
        {
            if(date != null)
            {
                return moment(date).format('DD.MM.YYYY. HH:mm')
            }
            else
            {
                return null;
            }
        },
        normalDate(date)
        {
            if(date != null) {
                return moment(date).format('DD.MM.YYYY.')
            }
            else
            {
                return null;
            }
        },
        create()
        {
            var that = this;
            axios.post('/licences/create',).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.loading = false;
                    that.$toast.open(response.data.message);
                    window.location.replace("/licences/show/"+response.data.agreement.id);
                }
                else {
                    that.errors = response.data.errors;
                    that.$toast.error(response.data.message);
                }
            })
        },
        deleteAgreement(id)
        {
            var that = this;
            axios.post('/licences/delete/'+id).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.agreements = response.data.agreements;
                    that.$toast.open(response.data.message);
                }
                else {
                    that.$toast.error(response.data.message);
                }
            });
        }
    }
}
</script>
